export const enPatientRTMTranslations = {
  rtm: {
    activeDays: {
      cpt85_77: {
        header: 'Patient Active Days (CPT 98985/77)',
        modal: {
          title: 'Understanding CPT Code 98985/77',
          description:
            'Code 98985/77 tracks your patient’s adherence to their care plan through exercises, gait measurements, and questionnaires. To qualify, they must use the OneStep app for physical activity on 2 out of 30 days (code 98985), or 16 out of 30 days (code 98977). This can be through active use or background monitoring during walks.',
          rtmOff: 'RTM is currently OFF for this patient.',
        },
      },
      learnMore: 'Learn More',
      status: {
        empty: 'No activity yet',
        inProgress: 'Activity in progress',
        warning: 'Attention!',
        done: 'Unit achieved',
        missing: 'Unit lost',
      },
      messages: {
        empty:
          'Patient needs {{missingDays}} active days in {{remainingDays}} days to achieve this unit. {{encouragement}}',
        inProgress:
          'Patient has {{remainingDays}} days left to complete {{missingDays}} active {{dayWord}}. Keep it going!',
        warning:
          'Patient needs {{missingDays}} more active day in {{remainingDays}} days to achieve the unit. Almost there!',
        done: 'Patient achieved the unit with {{activeDays}} active days. Great work!',
        missing: 'Patient didn’t complete {{unitCount}} active days in time. Unit lost.',
      },
      encouragement: {
        start: 'Encourage them to get started!',
        letsStart: 'Let’s get started!',
      },
      tooltip: {
        title: 'Patient Active Days',
      },
    },
    monitoringTime: {
      cpt80_81: {
        header: 'Clinician Monitoring Time (CPT 98980/81)',
        missingTimeState: 'Reporting a Monitoring Event is required for RTM Code 98980/1',
        modal: {
          title: 'Understanding CPT Codes 98980/81',
          description:
            'You need to spend at least <bold>20 minutes</bold> reviewing patient data, prescribing exercises, and following up via chat, phone, or video call. The first 20 minutes is billed under 98980, and any additional 20-minute segments under 98981. Remember, to bill both, you must complete <bold>at least one</bold> monitoring event each month.',
        },
        rtmTimerStates: {
          active:
            'The clinician is currently engaged with a patient data page that qualifies under the 98980 code.',
          idle: 'The clinician has not interacted with the eligible patient data page for more than {{timeout}}.',
          inActive: 'The clinician is viewing a page that does not qualify under the 98980 code.',
          missing:
            'The clinician has not reported a required monitoring event within the designated timeframe.',
        },
      },
      cpt79_80_81: {
        header: 'Clinician Monitoring Time (CPT 98979/80/81)',
        missingTimeState: 'Reporting a Monitoring Event is required for RTM Code 98979/80/81.',
        modal: {
          title: 'Understanding CPT Codes 98979/80/81',
          description:
            'You need to spend at least <bold>10 minutes</bold> reviewing patient data, prescribing exercises, and following up via chat, phone, or video call. The first 10 minutes is billed under 98979, replaced by 98980 when you reach 20 minutes, and any additional 20-minute segments under 98981. Remember, to bill any of these codes, you must complete <bold>at least one</bold> monitoring event each month.',
        },
        rtmTimerStates: {
          active:
            'The clinician is currently engaged with a patient data page that qualifies under the 98979/80/81 code.',
          idle: 'The clinician has not interacted with the eligible patient data page for more than {{timeout}}.',
          inActive:
            'The clinician is viewing a page that does not qualify under the 98979/80/81 code.',
          missing:
            'The clinician has not reported a required monitoring event within the designated timeframe.',
        },
      },
      timeToComplete: 'You need {{time}} of monitoring time to complete {{unit}}.',
      status: {
        inProgress: 'Monitoring event documented',
        done: 'Well done! you’ve completed all units',
      },
    },
    educationEvent: {
      header: 'Onboarding and education event (CPT 98975)',
      status: {
        eventDocumented: 'Event documented',
        eventNotDocumented: 'Event not documented',
      },
      btnLabels: {
        eventDocumented: 'View event',
        eventNotDocumented: 'Add event',
      },
      modal: {
        title: 'Understanding CPT Code 98975',
        description:
          'Code 98975 covers the initial setup and patient education for Remote Therapeutic Monitoring (RTM). To qualify, you must onboard your patient to the OneStep app and instruct them on how to use it to track their progress. Simply report the education event on the platform to fulfill the requirement. This code is billed once per episode of care.',
      },
    },
  },
};
